<template>
  <tm-dropdown-item
    class="item"
    :class="[`item--${itemStyle}`, className]"
    tabindex="-1"
    :focused="focused"
    :disable="disable"
    :loading="loading"
    no-hover
    @click="$emit('click')"
  >
    <slot />
  </tm-dropdown-item>
</template>

<script lang="ts">
import { defineComponent, type PropType } from '@/composition/vue/compositionApi'
import TmDropdownItem from '@/components/shared/TmDropdownItem.vue'

export default defineComponent({
  components: { TmDropdownItem },
  inheritAttrs: false,
  props: {
    itemStyle: {
      type: String as PropType<'regular' | 'semi-bold'>,
      default: 'regular',
    },
    className: {
      type: String,
      default: 'px-3',
    },
    focused: {
      type: Boolean,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    click: () => true,
  },
})
</script>

<style lang="scss" scoped>
.item {
  &--regular {
    min-height: 36px;
    font-weight: $regular-font;
  }
  &--semi-bold {
    font-weight: $semi-bold-font;
  }
}
</style>
